<div class="layout-auto-1">
	<div *ngIf="!SummaryLeistungTable?.isLoading && SummaryLeistungTable?.isEmpty" class="splash empty">
		<p>{{getRessource('Es wurden keine Daten gefunden!')}}</p>
	</div>
	<div class="content" *ngIf="!SummaryLeistungTable?.isEmpty">
		<exg-data-list #VCLeistungList
		               selectKey="leID"
		               [displayState]="0"
		               [rowSource]="SummaryLeistungTable?.data">
			<ng-template #rowTemplate let-serviceRecord>
				<div class="list-row list-row-auto-1-auto app-cursor-pointer"
				     (click)="onClickOpenServiceRecord(serviceRecord)">
					<div></div>
					<div>
						<div>
							<span class="chip app-chip-status bg-blue"
							      *ngIf="serviceRecord.AuftraggeberShort">{{serviceRecord.AuftraggeberShort}}</span>
							<span class="chip app-chip-status"
							      [ngClass]="getRessource('ServiceRecordStatusClass.' + serviceRecord.leState)">{{getRessource('ServiceRecordStatus.' + serviceRecord.leState)}}</span>
							<ng-container *ngIf="serviceRecord.leState === 5">
								<span class="chip app-chip-status bg-blue" *ngIf="serviceRecord.lePickU">
									<i class="fas fa-user"></i> {{serviceRecord.lePickU}}
								</span>
								<span class="chip app-chip-status bg-blue" *ngIf="serviceRecord.lePickD">
									<i class="fas fa-clock"></i> {{serviceRecord.lePickD | excDate: 'dd.MM.yyyy'}}
								</span>
							</ng-container>
						</div>
						<div class="list-primary-text"
						     [tooltip]="serviceRecord.leNr + ' - ' + serviceRecord.leName">
							{{serviceRecord.leNr}} - {{serviceRecord.leName}}
						</div>
						<div class="list-secondary-text">
							{{serviceRecord.leCRD | excDate: 'dd.MM.yyyy'}} {{serviceRecord.leCRU}}
						</div>
					</div>
					<div class="list-metadata">
						<div class="typo-right">
							<strong>{{sumTotal(serviceRecord) | excCurrency: '€'}}</strong>
						</div>
					</div>
				</div>
			</ng-template>
		</exg-data-list>
	</div>
</div>
